import { Bot } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface AgentToggleButtonProps {
  active?: boolean;
  className?: string;
  onClick: () => void;
}

export function AgentToggleButton({ active = false, className, onClick }: AgentToggleButtonProps) {
  return (
    <Button
      aria-label="Toggle AI assistant"
      className={cn(
        "h-9 rounded-lg border-border/70 bg-background-elevated/80 text-text-tertiary shadow-sm hover:text-text-primary",
        active && "border-accent/40 bg-accent-subtle text-accent",
        className,
      )}
      size="icon"
      type="button"
      variant="secondary"
      onClick={onClick}
    >
      <Bot className="h-4 w-4" />
    </Button>
  );
}
